import { render } from "./sharePopup.vue?vue&type=template&id=45d288fb"
import script from "./sharePopup.vue?vue&type=script&lang=js"
export * from "./sharePopup.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/vhosts/emblematic.es/tour.emblematic.es/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__